module.exports = __webpack_public_path__ + "img/outDefault-dark.5d0365d1.svg";